import { toast } from 'react-toastify';

export default () =>
  toast.error('Não foi possível realizar esta ação. Tente novamente.');
